import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupOtp = () => {
  const { t } = useTranslation();
  return {
    otp: Yup.string()
      .required(
        t("validation.required", {
          otp: t("page.otp"),
        })
      )
      .min(4, "It should be 4 numbers"),
  };
};
